import {
  LanguageString,
  PageConfig,
  StoryboardComponentDependencies,
} from '../../../common/components/dashboards/types';
import { FinancialYearYearlyTimesliderGranularity } from '../../../common/components/timeslider/constants';
import { TimeSliderTypes } from '../../../common/components/timeslider/types';
import { Languages } from '../../../constants';
import { getTdHoldingsHumanCapitalStoryboardComponents } from './td-holdings-human-capital-chart-helpers';

const DASHBOARD_ID = 'td_holdings_human_capital';

export const getTdHoldingsHumanCapitalDbPageConfig = (pageOption: {
  pageId: number;
  dashboardId: string;
  title: LanguageString;
}): PageConfig => {
  const { pageId, dashboardId, title } = pageOption;
  const pageComponents = (deps: StoryboardComponentDependencies) =>
    getTdHoldingsHumanCapitalStoryboardComponents(deps);

  return {
    pageId: pageId.toString(),
    dashboardId,
    pageNumber: pageId,
    enabled: true,
    title,
    pageOptions: {
      displayOptions: {
        enabled: true,
      },
      timeOptions: {
        timeSliderEnabled: true,
        timeSliderType: TimeSliderTypes.POINT,
        defaultGranularity: FinancialYearYearlyTimesliderGranularity,
      },
      filterTray: {
        enabled: true,
      },
      dataView: {
        enabled: false,
      },
      segmentationLevel1: {
        enabled: false,
      },
      segmentationLevel2: {
        enabled: false,
      },
      benchmark: {
        enabled: false,
      },
      forecast: {
        enabled: false,
      },
    },
    gridCols: 5,
    gridRows: 2,
    configType: 'componentConfigs',
    components: pageComponents,
  };
};

export const getTdHoldingsHumanCapitalDbPageConfigs = (
  dashboardId: string = DASHBOARD_ID
): PageConfig[] => [
  getTdHoldingsHumanCapitalDbPageConfig({
    pageId: 1,
    dashboardId,
    title: {
      [Languages.EN]: 'Human Capital Management',
      [Languages.JA]: '人的資本開示',
    },
  }),
];
